import script from "./FocoChatPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./FocoChatPanel.vue?vue&type=script&setup=true&lang=ts"

import "./FocoChatPanel.vue?vue&type=style&index=0&id=cdc10c20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cdc10c20"]])

export default __exports__